// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const GlobeMd = ({ color = "white", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M17.5 10C17.5 14.1422 14.1422 17.5 10 17.5M17.5 10C17.5 5.85787 14.1422 2.5 10 2.5M17.5 10C17.5 11.3807 14.1422 12.5 10 12.5C5.85787 12.5 2.5 11.3807 2.5 10M17.5 10C17.5 8.61925 14.1422 7.5 10 7.5C5.85787 7.5 2.5 8.61925 2.5 10M10 17.5C5.85787 17.5 2.5 14.1422 2.5 10M10 17.5C8.61925 17.5 7.5 14.1422 7.5 10C7.5 5.85787 8.61925 2.5 10 2.5M10 17.5C11.3807 17.5 12.5 14.1422 12.5 10C12.5 5.85787 11.3807 2.5 10 2.5M10 2.5C5.85787 2.5 2.5 5.85787 2.5 10" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
